import React from 'react'
import { ListGroup } from 'react-bootstrap'
import SearchResultIntercomArticle from './SearchResultIntercomArticle'

const SearchListIntercomArticles = ({ intercomArticles, searchValue }) => {
  if(intercomArticles.data.length === 0) {
    return null
  }

  const articlesPath = `https://intercom.help/check-cherry/en/`
  const moreResultsPath = `${articlesPath}?q=${encodeURIComponent(searchValue)}`
  console.log({ moreResultsPath })

  return (
    <div className="mb-3">
      <h5>
        <a href={moreResultsPath} className="text-dark">
          Support Articles &raquo;
        </a>
      </h5>
      <ListGroup>
        {intercomArticles.data.map(result => (
          <SearchResultIntercomArticle key={result.id} result={result} />
        ))}
      </ListGroup>
      <div className="text-end mt-2">
        <a className="text-muted" href={moreResultsPath}>Search all support articles &raquo;</a>
      </div>
    </div>
  )
}

export default SearchListIntercomArticles
